export default __webpack_public_path__ + "static/media/jolt-100-2.46a35c25.jpg";